import { useSystemInfo } from '../../hooks/system/useSystemInfo.js';

export default function Systeminfo() {    

    const { systemInfo, error } = useSystemInfo();

    return (
        <>
            <div className='container mt-6'>
                <div className="alert alert-light">
                    <h5>Cotizador TAEC</h5>
                    <p>Actualmente estás utilizando la versión: <b>{systemInfo?.appVersion ?? 'Cargando...'}</b> - Compilación estable</p>
                    <h6>Detalles del servidor:</h6>
                    {error && (
                        <p className="text-danger">{error}</p>
                    )}                              
                    
                    {systemInfo ? ( 
                        <ul>  
                            <li>Tipo de OS: <b>{systemInfo.osType}</b></li>
                            <li>Plataforma: <b>{systemInfo.osPlatform}</b></li>
                            <li>Versión del OS: <b>{systemInfo.osRelease}</b></li>
                            <li>Arquitectura de CPU: <b>{systemInfo.cpuArchitecture}</b></li>
                            <li>Versión de PHP: <b>{systemInfo.phpVersion}</b></li>
                            <li>Versión de NodeJS: <b>{systemInfo.nodeVersion}</b></li>
                            <li>Versión de ReactJS: <b>{systemInfo.reactVersion}</b></li>
                            <li>Versión de NPM: <b>{systemInfo.npmVersion}</b></li>
                            <li>Tipo de base de datos: <b>{systemInfo.dbType}</b></li>
                            <li>Versión de base de datos: <b>{systemInfo.dbVersion}</b></li>
                            {systemInfo.isHttps ? (
                                <li className="text-success">HTTPS:  OK <i className="bi bi-check-circle-fill ms-1"></i></li>
                            ) : (
                                <li className="text-warning">HTTPS:  <i className="bi bi-exclamation-triangle-fill ms-1"></i> <b>Se recomienda habilitar HTTPS</b></li>
                            )}
                        </ul>                  
                    ) : (
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    )}
                </div>
            </div>            
        </>
    );
}